// =========================================
// PP — Stats Carousel (Swiper)
// =========================================
import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.block-pp-stats');
    if (!blocks.length) return;

    blocks.forEach((block) => {
        const swiperEl = block.querySelector('.pp-stats__swiper');
        if (!swiperEl) return;

        const swiper = new Swiper(swiperEl, {
            modules: [Navigation, A11y],
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            breakpoints: {
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
            },
        });

        block.querySelectorAll('.pp-stats__arrow').forEach((btn) => {
            btn.addEventListener('click', () => {
                if (btn.dataset.direction === 'next') swiper.slideNext();
                else swiper.slidePrev();
            });
        });
    });
});
